export default {"src":"/_next/static/media/partnership.6f4a30d5.svg","height":204,"width":144};